import CountriesContainer from './countries-container';

export default CountriesContainer;
